<template>
  <!-- 编辑修改乘机人 修改出行人-->
  <div>
    <van-popup
      v-model="isShow"
      :close-on-click-overlay="false"
      :close-on-popstate="true"
      :get-container="getContainer"
      :lock-scroll="true"
      class="full-height full-width"
      position="right"
    >
      <div class="full-height">
        <ld-header @click-left="toggle">
          {{ $t('C184', '修改出行人') }}
        </ld-header>
        <div>
          <van-cell-group>
            <!--乘客类型 -->
            <van-field
              v-model="psgTypeName"
              :label="$t('C114','乘客类型')"
              :readonly="true"
              disabled
              input-align="left"
            />
            <!-- <van-action-sheet
              v-model="showPsgType"
              :actions="[
                {key:1,name:'成人'},
                {key:2,name:'儿童'},
                {key:3,name:'婴儿'}
              ]"
              cancel-text="取消"
              @select="psgTypeSelect"
            /> -->
            <!-- 中文版名字 -->
            <van-field
              v-model="name"
              :disabled="caneditnew"
              :label="$t('D007','姓名')"
              :placeholder="$t('D007','姓名')"
              input-align="left"
              clearable
              v-if="!isShowLabel"
            />
            <!-- 英文版 -->
            <div v-else>
              <van-cell
                title="姓（拼音）"
                label="Surname"
                required
                clearable
                :style="{color : caneditnew ? '#c8c9cc' : '' }"
              >
                <van-field
                  clearable
                  :disabled="caneditnew"
                  v-model="Pinyin.surname"
                  placeholder="如 HAN"
                  @blur.prevent="changeBlur"
                  @input="SurName"
                  :error-message="errormessage(Pinyin.surname)"
                />
              </van-cell>
            </div>
            <!--名-->
            <div>
              <span
                v-if="!isShowLabel"
              />
              <van-cell
                title="名（拼音）"
                label="Given name"
                required
                clearable
                :style="{color : caneditnew ? '#c8c9cc' : '' }"

                v-else
              >
                <van-field
                  clearable
                  :disabled="caneditnew"
                  v-model="Pinyin.name"
                  placeholder="如 MEIMEI"
                  @blur.prevent="changeBlur"
                  @input="Sname"
                  :error-message="errormessage(Pinyin.name)"
                />
              </van-cell>
            </div>
            <!--性别 -->
            <div class="sex">
              <div class="sexxt" :style="{color : caneditnew ? '#c8c9cc' : '' }">性别</div>
              <van-radio-group v-model="emp.sex" class="semf" :disabled="caneditnew">
                <van-radio name="M">男</van-radio>
                <van-radio name="F">女</van-radio>
              </van-radio-group>
            </div>

            <van-field
              :value="emp.cardName"
              :label="$t('D003','证件类型')"
              :disabled="caneditnew"
              :readonly="true"
              input-align="left"
              is-link
              @click="showCardType=!showCardType"
            />
            <!-- 证件类型 -->
            <van-action-sheet
              v-if="!caneditnew"
              v-model="showCardType"
              :actions="[
                {key:'NI',name:'身份证'},
                {key:'PP',name:'护照'},
                {key:'JR',name:'军人证'},
                {key:'HX',name:'回乡证'},
                {key:'TB',name:'台胞证'},
                {key:'HR',name:'户口簿'},
                {key:'BC',name:'出生证明',subname:'限14天-2周岁内婴儿'},
                {key:'FI',name:'外国人永久居留身份证'},
                {key:'HM',name:'港澳台居民居住证'},
              ]"
              cancel-text="取消"
              @select="cardChange"
            />
            <!-- 身份证 -->
            <div v-if="identityCard">
              <van-field
                v-model="emp.cardNo"
                :disabled="caneditnew"
                :label="$t('D008','证件号码')"
                :placeholder="$t('D008','证件号码')"
                maxlength="18"
                required
                type="text"
                @input="empCarNo"
              />
              <!-- 出生日期 -->
              <van-field
                v-model="emp.born"
                :label="$t('D013','出生日期')"
                :disabled="caneditnew"
                :readonly="true"
                input-align="left"
                is-link
                @click="dateShowAction('born')"
              />
              <!-- 出生日期日历 -->
              <van-popup
                v-model="showDate"
                :close-on-popstate="true"
                :lock-scroll="true"
                position="bottom"
              >
                <van-datetime-picker
                  v-model="currentDate"
                  :max-date="maxDate"
                  :min-date="minDate"
                  type="date"
                  @cancel="showDate=false"
                  @confirm="getBorn"
                />
              </van-popup>
            </div>
            <!--护照-->
            <div v-if="passport">
              <van-field
                v-model="emp.cardNo"
                :disabled="caneditnew"
                :label="$t('D005','护照')"
                placeholder="与证件保持一致"
                clearable
                @blur.prevent="changeBlur"
              />
              <van-field
                :label="$t('D009','证件有效期')"
                readonly
                clickable
                :disabled="caneditnew"
                placeholder="与证件保持一致"
                @click="dateShowAction('passportPeriod')"
                v-model="emp.passportPeriod"
              />
              <van-field
                :label="$t('D013','出生日期')"
                :disabled="caneditnew"
                readonly
                clickable
                placeholder="与证件保持一致"
                @click="dateShowAction('born')"
                v-model="emp.born"
              />

              <van-field
                :disabled="caneditnew"
                :label="$t('D017','国籍')"
                v-show="showHeader"
                v-model="emp.nationName"
                required
                is-link
                @click="$refs.nation.toggle()"
                input-align="left"
                placeholder="与证件保持一致"
                readonly
              />
              <!-- <van-field
              v-if="lingj=='10902'"
                        v-model="emp.placeOfIssueName"
                        :readonly="true"
                        input-align="left"
                        is-link
                        label="证件签发地"
                        @click="$refs.nation.toggle(true)"
                    /> -->

            </div>
            <!--台胞证-->
            <div v-if="TaiwanPackageCertificate">
              <van-field
                :disabled="caneditnew"
                v-model="emp.cardNo"
                :label="$t('D008','证件号码')"
                placeholder="与证件保持一致"
                clearable
                @focus.prevent="changefocus"
              />
              <van-field
                :disabled="caneditnew"
                :label="$t('D009','证件有效期')"
                readonly
                clickable
                placeholder="与证件保持一致"
                @click="dateShowAction('passportPeriod')"
                v-model="emp.passportPeriod"
              />
              <van-field
                :disabled="caneditnew"
                v-if="nati"
                readonly
                clickable
                :label="$t('D017','国籍')"
                v-model="emp.nationName"
                placeholder="与证件保持一致"
                required
                @click="$refs.nation.toggle()"
              />
              <van-field
                :disabled="caneditnew"
                :label="$t('D013','出生日期')"
                readonly
                clickable
                placeholder="与证件保持一致"
                @click="dateShowAction('born')"
                v-model="emp.born"
              />
            </div>
            <!--出生证明-->
            <div v-if="BirthCertificate">
              <van-field
                :disabled="caneditnew"
                v-model="emp.cardNo"
                :label="$t('D008','证件号码')"
                placeholder="与证件保持一致"
                clearable
                @focus.prevent="changefocus"
              />
              <van-field
                :disabled="caneditnew"
                :label="$t('D009','证件有效期')"
                readonly
                clickable
                placeholder="与证件保持一致"
                @click="dateShowAction('otherPeriod')"
                v-model="emp.passportPeriod"
              />
              <van-field
                :disabled="caneditnew"
                :label="$t('D013','出生日期')"
                readonly
                clickable
                placeholder="与证件保持一致"
                @click="dateShowAction('born')"
                v-model="emp.born"
              />
            </div>
            <!--港澳台-->
            <div v-if="HongKongMacaoAndTaiwan">
              <van-field
                :disabled="caneditnew"
                v-model="emp.cardNo"
                :label="$t('D008','证件号码')"
                placeholder="与证件保持一致"
                clearable
                @focus.prevent="changefocus"
              />
              <van-field
                :disabled="caneditnew"
                :label="$t('D009','证件有效期')"
                readonly
                clickable
                placeholder="与证件保持一致"
                @click="dateShowAction('otherPeriod')"
                v-model="emp.passportPeriod"
              />
              <van-field
                :disabled="caneditnew"
                :label="$t('D013','出生日期')"
                readonly
                clickable
                placeholder="与证件保持一致"
                @click="dateShowAction('born')"
                v-model="emp.born"
              />
            </div>

            <!-- 手机号 -->
            <van-field
              v-model="emp.phoneNumber"
              :disabled="caneditnew"
              :label="$t('F008','手机号')"
              :placeholder="$t('F008','手机号')"
              clearable
              max="13"
              required
              type="tel"
            />
            <!-- 是否公务员 -->
            <van-field
              v-show="pageCtrl.isCivil&&tkSearchInfo.queryStr.showGpProduct"
              v-model="emp.isCivilName"
              :disabled="caneditnew"
              :readonly="true"
              input-align="left"
              is-link
              label="是否公务员"
              placeholder="是否公务员"
              type="text"
              @click="showCivil=!showCivil"
            />
            <van-action-sheet
              v-model="showCivil"
              :actions="[
                {key:'0',name:'否'},
                {key:'1',name:'是'},
              ]"
              cancel-text="取消"
              @select="civilChange"
            />
            <div v-show="emp.isCivil==1&&tkSearchInfo.queryStr.showGpProduct">
              <van-field
                v-show="emp.isCivil==1"
                v-model="emp.civilCheckName"
                :readonly="true"
                :disabled="caneditnew"
                input-align="left"
                is-link
                label="验证方式"
                placeholder="验证方式"
                type="text"
                @click="showCivilCheck=!showCivilCheck"
              />
              <van-action-sheet
                v-model="showCivilCheck"
                :actions="[
                  {key:'1',name:'公务卡'},
                  {key:'2',name:'预算单位'},
                ]"
                cancel-text="取消"
                @select="civilCheckChange"
              />
              <van-field
                v-show="emp.civilCheck==1"
                v-model="emp.civilBankName"
                :readonly="true"
                :disabled="caneditnew"
                input-align="left"
                is-link
                label="预算银行"
                placeholder="预算银行"
                type="text"
                @click="showBank=!showBank"
              />
              <van-action-sheet
                v-model="showBank"
                :actions="sortedBanks"
                cancel-text="取消"
                @select="backChange"
              />
              <van-field
                :disabled="caneditnew"
                v-show="emp.civilCheck==2"
                v-model="emp.unitAddress"
                clearable
                label="预算单位"
                placeholder="预算单位地址"
                type="text"
              />
            </div>
          </van-cell-group>
          <div class="pad">
            <ld-button
              main
              size="lg"
              @click.native="comple"
            >
              {{ $t('B006', '确定') }}
            </ld-button>
          </div>
          <!-- 日期组件 -->
          <van-popup
            v-model="showDate"
            :close-on-popstate="true"
            :lock-scroll="true"
            position="bottom"
          >
            <van-datetime-picker
              v-model="currentDate"
              :min-date="minDate"
              type="date"
              @cancel="showDate=false"
              @confirm="getBorn"
            />
          </van-popup>
          <!-- 国籍组件 -->
          <ld-nation
            v-show="!caneditnew"
            ref="nation"
            @selected="nationSelect"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import ldButton from 'Common/ldButton'
import {ActionSheet, Cell, CellGroup, DatetimePicker, Field, Popup, RadioGroup, Radio} from 'vant'
import {formatDate} from 'Utils/dateUtil'
import {getIDcardInfo, getName, setName} from 'Utils/publicFun'
import {excludeSpecial} from 'Utils/string'
import {mapGetters} from 'vuex'
import contactsInteractor from 'Domain/use-cases/contacts-interactor'
import {validators} from 'Utils/valid'

import {changeBlur, changefocus} from 'Utils/tools'
import ldNation from 'Components/ldNation'
import { jsGetAgeaccurate} from 'Utils/dateUtil'
import { isGat } from 'Utils/gattools'

export default {
  name: 'LdEditPsg',
  components: {
    ldButton, ldNation,
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  props: {
    psgInfo: {
      type: Object,
      default: function() {
        return {}
      }
    },
    element: {
      type: String,
      default: ''
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    cplx: {
      //产品类型
      type: String,
      default: '10901'
    },
  },
  data() {
    return {
      isShow: false,
      isShowLabel: false,
      passport: false,//护照
      TaiwanPackageCertificate: false, //台胞证
      HongKongMacaoAndTaiwan: false,//港澳台
      BirthCertificate: false,//出生证明
      identityCard: true,//身份证
      nati: false,//国籍
      dateShow: false,
      currentCheckBorn: '', //判断出生日期还是到期日期
      showPsgType: false,
      showCardType: false,
      showDate: false,
      showCivil: false,//
      showCivilCheck: false,
      showBank: false,
      psgTypeName: '',
      currentDate: new Date(),
      minDate: new Date('1940-01-01'),
      maxDate: new Date(),
      emp: {},
      name: '', //中文版名字字段
      bankArr: [],
      zjh: '',
      zjhNotEdit: false,
      priorityBanks: [
        '中国银行',
        '中国民生银行',
        '中国农业银行',
        '中国建设银行',
        '中国工商银行',
        '中国光大银行',
        '招商银行',
        '上海浦东发展银行',
        '交通银行',
        '北京银行',
      ],
      // 后续跟新
      Pinyin: {
        surname: '',
        name: '',
        Pinyinz: '',
      },
      detail: {
        isValid: 1,
        sex: 'M',
        parDepts: '',
        passportPeriod: '',
        nation: '',
        nationName: '',
        engName: '',//英文姓名
        empName: '',
        cardType: '',//身份类型
      },
      lingj: '',//是不是国际
    }
  },
  created() {
    this.caneditnew = this.canedit(this.emp)

  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
      pageCtrl: 'serviceCtrl', //页面控制信息
      tkSearchInfo: 'tk/tkSearchInfo'
    }),
    sortedBanks() {
      const banksCopy = this.bankArr.slice()
      banksCopy.sort((a, b) => {
        const indexA = this.priorityBanks.indexOf(a.cName)
        const indexB = this.priorityBanks.indexOf(b.cName)

        if(indexA !== -1 && indexB !== -1) {
          return indexA - indexB
        } else if(indexA !== -1) {
          return -1
        } else if(indexB !== -1) {
          return 1
        }
        return 0
      })
      return banksCopy
    }
  },

  methods: {
    errormessage(val){
      if(val){
        const regex = /^[a-zA-Z]+$/;
        if(!regex.test(val)){
          return "请以英文输入,勿含空格或其他特殊字符"
        }
      }else{
        return ''
      }
    },
    canedit(psg) {
      // if (this.pageCtrl.isShowCcsqd){ //lxy:出差申请模式不允许修改出行人姓名
      // 	return true
      // }
      // return !((this.userInfo.vipCorp.tripType == 1 && this.userInfo.vipCorp.bookStyle == 2) || psg.empId || psg.conempId)
      // if (this.userInfo && this.userInfo.vipCorp && this.userInfo.vipCorp.bookStyle && this.userInfo.empInfo) {
      if(this.userInfo && this.userInfo.vipCorp && this.userInfo.empInfo) {
        const reg = /^(?:\d+)(.{4})$/
        // 申请单模式用户端统一不能修改人员信息
        // if (this.userInfo.vipCorp.bookStyle === 2) {
        //   this.zjh = psg.cardNumber.replace(reg, '****\$1');
        //   this.zjhNotEdit = true;
        //   return true;
        // }
        // if (this.userInfo.vipCorp.bookStyle === 1 && this.userInfo.empInfo.xgygxx === 0) {
        if(this.userInfo.empInfo.xgygxx === 0) {
          if(this.psgInfo && this.psgInfo.psgType) {
            if(this.psgInfo.psgType == 2) {
              this.psgTypeName = '儿童'
            } else if(this.psgInfo.psgType == 3) {
              this.psgTypeName = '婴儿'
            } else {
              this.psgTypeName = '成人'
            }
          }
          if(psg.cardNumber) {
            this.zjh = psg.cardNumber.replace(reg, '****\$1')
          }
          this.zjhNotEdit = true
          return true
        }
      }
      this.zjh = psg.cardNumber
      return false
    },
    //乘机人类型
    psgTypeSelect(item) {
      this.emp.psgType = item.key
      this.psgTypeName = item.name
      this.showPsgType = false
    },
    //证件类型
    cardChange(item) {
      let key = item.key
      let name = item.name
      this.emp.cardNumber = ''
      this.emp.cardName = item.name
      this.emp.cardType = item.key
      this.showCardType = false
      this.cardType(item)
      // 更新代码部分
      if(key == 'NI' || name == '身份证') {
        this.identityCard = true//身份证
        this.passport = false//护照
        this.TaiwanPackageCertificate = false//台胞证
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.isShowLabel = false//切换拼音
        this.emp.cardType = 'NI'//身份证
        this.emp.empName = this.emp.empName
        this.emp.cardName = '身份证'
      } else if(key == 'PP' || name == '护照') {
        this.isShowLabel = true//切换拼音
        this.identityCard = false//身份证
        this.passport = true//护照
        this.TaiwanPackageCertificate = false//台胞证
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.emp.cardType = 'PP'//身份证
        this.emp.cardName = '护照'
        this.Pinyin.surname = ""
        this.Pinyin.name = ""
      } else if(key == 'TB' || name == '台胞') {
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.emp.cardType = 'TB'//身份证
        this.emp.cardName = '台胞'
      } else if(key == 'HX' || name == '回乡') {
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.emp.cardType = 'HX'//身份证
        this.emp.cardName = '回乡'
      } else if(key == 'HR' || name == '户口簿') {
        this.isShowLabel = false//切换拼音
        this.identityCard = true//身份证
        this.passport = false//护照
        this.TaiwanPackageCertificate = false//台胞证
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.emp.chName = this.detail.empName
        this.emp.cardType = 'HR'//身份证
        this.emp.cardName = '户口簿'
      } else if(key == 'BC' || name == '出生证明') {
        this.isShowLabel = false//切换拼音
        this.BirthCertificate = true//出生证明
        this.identityCard = false//身份证
        this.passport = false//护照
        this.TaiwanPackageCertificate = false//台胞证
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'BC'//身份证
        this.detail.cardName = '出生证明'
      } else if(key == 'HY' || name == '海员') {
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'HY'//身份证
        this.detail.cardName = '海员'
      } else if(key == 'JR' || name == '军人') {
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.emp.cardType = 'JR'//身份证
        this.emp.cardName = '军人'
      } else if(key == 'GA' || name == '港澳台通行') {
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.emp.cardType = 'GA'//身份证
        this.emp.cardName = '港澳台通行'
      } else if(key == 'TW' || name == '台湾通行证') {
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.emp.cardType = 'TW'//身份证
        this.emp.cardName = '台湾通行证'
      } else if(key == 'FI' || name == '外国人永久居留证') {
        this.nati = true
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.emp.cardType = 'FI'//身份证
        this.emp.cardName = '外国人永久居留证'
      } else if(key == 'HM' || name == '港澳合居民居住证') {
        this.isShowLabel = true//切换拼音
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.BirthCertificate = false//出生证明
        this.identityCard = false//身份证
        this.passport = false//护照
        this.TaiwanPackageCertificate = true//台胞证
        this.emp.cardType = 'HM'//身份证
        this.emp.cardName = '港澳合居民居住证'
      }
      var pattern = /^[\u4e00-\u9fa5]+$/; //验证是否是中文名字
      let Englishname = pattern.test(this.emp.empName)
      //需要判断一下是常旅客还是员工，字段不一样
      if(this.psgInfo.contactsId) {//常旅客
        let chNamei
        this.psgInfo.chName ? chNamei = this.psgInfo.chName : chNamei = this.psgInfo.engName
        if(chNamei.includes('/')) {
          this.Pinyin.surname = chNamei.split('/')[0]
          this.Pinyin.name = chNamei.split('/')[1]
        }
      } else {//员工
        if(this.psgInfo.empName.includes('/')) {
          this.Pinyin.surname = this.psgInfo.empName.split('/')[0]
          this.Pinyin.name = this.psgInfo.empName.split('/')[1]
        }
      }
    },
    //出生日期
    getBorn(item) {// 点击日期完成事件
      this.showDate = false
      let dateborn = formatDate(item).date
      this.currentCheckBorn == "born" ? this.emp.born = dateborn : this.emp.passportPeriod = dateborn
      const ageCategory = calculateAgeCategory(this.emp.born)
      if(ageCategory == 1) {
        this.psgTypeName = '成人'
        this.emp.psgType = 1
      } else if(ageCategory == 2) {
        this.psgTypeName = '儿童'
        this.emp.psgType = 2
      } else if(ageCategory == 3) {
        this.psgTypeName = '婴儿'
        this.emp.psgType = 1
      }
    },
    //是否公务员
    civilChange(item) {
      this.emp.isCivil = item.key
      this.emp.isCivilName = item.name
      this.showCivil = false
    },
    //验证方式
    civilCheckChange(item) {
      this.emp.civilCheck = item.key
      this.emp.civilCheckName = item.name
      this.showCivilCheck = false
    },
    //银行
    backChange(item) {
      this.emp.civilBankId = item.id
      this.emp.civilBankName = item.cName
      this.showBank = false
    },
    //点击确定
    async comple() {
      this.getCardNum()
      if(isGat()){
        window.history.go(-1)
      }
      if(!this.emp.cardType && !this.emp.cardName) {
        this.$toast('请选择证件类型')
        return
      }
      if(this.emp.cardType == '' && this.emp.cardName == "") {
        this.$toast('请选择证件类型')
        return
      }
      if(this.emp.cardName == '身份证' && this.emp.cardType == "") {
        this.emp.cardType = "NI"
      }
      if(this.emp.cardType == "NI" && this.emp.cardName == '') {
        this.emp.cardName = "身份证"
      }
      if(this.emp.cardType == "NI") {//身份证字段是name赋值
        if(this.name) {
          let letters = /[a-zA-Z]/.test(this.name);
          if(letters) {
            this.$toast('身份证姓名不支持输入字母')
            return
          }
        }
        this.emp = setName(this.emp, this.name)
      } 
      //姓字是中英文的
      let other=['护照','台胞','回乡','户口簿','出生证明','海员','军人','港澳台通行','港澳合居民居住证']
      if(other.includes(this.emp.cardName)){
        if(!this.Pinyin.surname || !this.Pinyin.name) {
          this.$toast('请正确输入姓名')
          return
        }
        const regex1=/^[A-Za-z]+$/
        if(!regex1.test(this.Pinyin.surname) || !regex1.test(this.Pinyin.name)){
          this.$toast('请正确输入姓名')
          return
        }
        const regex = /^[A-Za-z\\/]+$/;
        if(!regex.test(this.emp.empName)){
          this.$toast('请正确输入姓名')
          return
        }
      }
      // else {//判断英文名是否录入
      //   if(!this.Pinyin.surname || !this.Pinyin.name) {
      //     this.$toast('请录入姓、名')
      //     return
      //   }
      // }
      if(!this.emp.nationName && this.emp.cardType == ('PP' || "TB" || "FI")) {//判断国籍是否录入
        this.$toast('请选择国籍')
        return
      }
      if(!this.emp.phoneNumber) {
        this.$toast('请输入手机号')
        return
      }
      if(this.emp.cardType == 'NI' || this.emp.cardType == 'PP') {
        if(!this.emp.cardNo.length) {
          this.$toast('证件号不能为空！')
          return
        } else {
          let errMSG = ''
          if(this.emp.cardType == 'NI') {
            this.emp.cardNumber = this.emp.cardNo
            if(!validators['is-idCard'](this.emp.cardNo).valid) {
              errMSG = validators['is-idCard'](this.emp.cardNo).msg
              this.$toast(errMSG)
              return
            }
          }
        }
      }

      // 判断是否公务员订票
      if(this.pageCtrl.isCivil == 1 && this.tkSearchInfo.queryStr.showGpProduct && this.emp.civilCheck == 1) {
        this.$api['emp/gpIdValid']({
          'psgName': this.name,
          'civilBankId': this.emp.civilBankId,
          'idType': this.emp.cardType,
          'idNo': this.emp.cardNo,
          'vcode': ''
        }).then(res => {
          var cache = res.data || {}
          if(cache.state == 0) {
            this.emp.isCivilError = '核验不通过，请核实信息是否准确。'
          } else {
            this.emp.isCivilError = ''
          }
          this.$toast(this.emp.isCivilError)
          this.$emit('selected', this.emp)
          this.toggle()
        }).catch(res => {
          this.emp.isCivilError = res.errMsg || '核验不通过，请核实信息是否准确。'
          this.$toast(this.emp.isCivilError)
          this.$emit('selected', this.emp)
          this.toggle()
        })
      } else {
        this.$emit('selected', this.emp)
        this.toggle()
      }
      if(this.emp.contactsId) {//这里调接口要区分开，员工跟常旅客编辑接口
        if(this.emp.chName.includes('·')) {//判断常旅客员工中是否有点
          this.emp.chName = this.emp.chName.split('·').join('');
          this.psgInfo.chName = this.psgInfo.chName.split('·').join('');
        }
        await contactsInteractor.saveContacts(this.emp) //常旅客员工编辑接口
      } else {
        if(this.emp.empName.includes('·')) {//判断工姓名中是否有点
          this.emp.empName = this.emp.empName.split('·').join('');
          this.psgInfo.empName = this.psgInfo.empName.split('·').join('');
        }
        await contactsInteractor.saveContact(this.emp) //员工编辑接口
      }
      return 0
    },
    getCardNum() {
      return this.emp.cardNo
    },
    cardType(item) {
      if(this.emp.cardType == 'NI') {
        this.emp.cardName = '身份证'
      } else if(this.emp.cardType == 'PP') {
        this.emp.cardName = '护照'
      } else if(this.emp.cardType == 'TB') {
        this.emp.cardName = '台胞'
      } else if(this.emp.cardType == 'HX') {
        this.emp.cardName = '回乡'
      } else if(this.emp.cardType == 'HR') {
        this.emp.cardName = '户口簿'
      } else if(this.emp.cardType == 'BC') {
        this.emp.cardName = '出生证明'
      } else if(this.emp.cardType == 'FI') {
        this.emp.cardName = '外国人永久居留证'
      } else if(this.emp.cardType == 'HM') {
        this.emp.cardName = '港澳台居民居住证'
      } else if(this.emp.cardType == 'ID') {
      }
      if(item == undefined) {
      } else {
        this.emp.cardType = item.key
      }
    },
    init() {
      this.emp = JSON.parse(JSON.stringify(this.psgInfo))
      if(this.emp.born == '' && this.emp.cardNo && this.emp.cardType == 'NI') {
        this.empCarNo(this.emp.cardNo)
      }
      if (this.emp.psgType == 1) {
        this.psgTypeName = '成人'
      } else if (this.emp.psgType == 2) {
        this.psgTypeName = this.$t('C116', '儿童')
      } else if (this.emp.psgType == 3) {
        this.psgTypeName = this.$t('C117', '婴儿')
      }
      this.$api['common/getBClass']({parNo: 141}).then(res => {
        var cache = res.data || {}
        var list = cache.list || []
        list.forEach(item => {
          item.name = item.cName
        })
        this.bankArr = list
      })
      if(this.emp.isCivil) {
        this.emp.isCivilName = '是'
      } else {
        this.emp.isCivilName = '否'
      }
      if(this.emp.civilCheck == 1) {
        this.emp.civilCheckName = '公务卡'
      } else if(this.emp.civilCheck == 2) {
        this.emp.civilCheckName = '预算单位'
      }
      this.name = getName(this.emp)
      this.cardType()
      let key = {
        key: this.emp.cardType,
        name: this.emp.cardName,
      }
      this.cardChange(key)
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if(this.element) {
        return document.querySelector(this.element)
      }
      return ''
    },
    toggle(lin) {
      this.lingj = lin
      this.isShow = !this.isShow
      this.caneditnew = this.canedit(this.emp)
    },
    // 后续更新代码事件
    changeBlur,
    SurName(event) {//名录入input事件
      // this.Pinyin.surname = event.replace(/[^a-zA-Z]/g, '')
      this.Pinyin.surname = this.Pinyin.surname.toUpperCase()
      this.emp.engName = this.Pinyin.surname + '/' + this.Pinyin.name
      this.emp.empName = this.Pinyin.surname + '/' + this.Pinyin.name
      this.emp.contactsId ? this.emp.chName = this.Pinyin.surname + '/' + this.Pinyin.name : '' //是否是常旅客
    },
    Sname(event) {//姓录入input事件
      // this.Pinyin.name = event.replace(/[^a-zA-Z]/g, '')
      this.Pinyin.name = this.Pinyin.name.toUpperCase()
      this.emp.engName = this.Pinyin.surname + '/' + this.Pinyin.name
      this.emp.empName = this.Pinyin.surname + '/' + this.Pinyin.name
      this.emp.contactsId ? this.emp.chName = this.Pinyin.surname + '/' + this.Pinyin.name : '' //是否是常旅客
    },
    dateShowAction(row) {// 弹出日期选择器事件
      if(!this.caneditnew) {
        this.currentCheckBorn = row
        this.showDate = true
      }

    },
    empCarNo($event) {//录入身份证input事件
      // if(this.emp.cardType == 'NI' || this.emp.cardType == 'HR') {
      const csrq = this.extractBirthDate($event)
      this.emp.born = csrq
      // }
    },
    extractBirthDate(idNumber) {
      let year = idNumber.substr(6, 4);
      let month = idNumber.substr(10, 2);
      let day = idNumber.substr(12, 2);
      return `${year}-${month}-${day}`;
    },
    nationSelect(nation, lin) {
      if(this.cplx == '10902') {
        this.$set(this.emp, 'placeOfIssueName', nation.cName)
        this.$set(this.emp, 'placeOfIssue', nation.id)
        this.$set(this.emp, 'nationName', nation.cName)
        this.$set(this.emp, 'nation', nation.id)
      } else {
        this.$set(this.emp, 'nationName', nation.cName)
        this.$set(this.emp, 'nation', nation.id)

      }
    },
  },
  watch: {
    isShow(newVal, oldVal) {
      if(newVal) {
        this.init()
      }
    },
    'zjh'(val) {
      this.emp.cardNumber = this.zjhNotEdit ? this.emp.cardNumber : excludeSpecial(val)
      if(this.emp.cardType === 'NI' && this.emp.cardNumber) {
        const born = getIDcardInfo(this.emp.cardNumber).born
        if(born) {
          this.emp.born = born
        }
      }
    },
    'emp.phoneNumber'(val) {
      this.emp.phoneNumber = excludeSpecial(val)
    },
    "emp.born":{//后续修改年龄类型跟着变化
      handler(naeval,oldvale){
        //判断类型是否"YYYY-MM-DD" 
        let pattern = /^\d{4}-\d{2}-\d{2}$/;
        let verification= pattern.test(naeval);
        if(oldvale && verification){
          let born= jsGetAgeaccurate(naeval)
          if(born>12){
            this.emp.psgType=1
            this.psgTypeName = '成人'
          }else if(born>2 && born<=12) {
            this.emp.psgType=2
            this.psgTypeName = this.$t('C116', '儿童')
          }else if(born<=2){
            this.emp.psgType=3
            this.psgTypeName = this.$t('C117', '婴儿')
          }
        }
      },   
      deep:true, immediate:true
    }
    
  }
}

function calculateAgeCategory(birthdate) {
  const today = new Date()
  const birthdateArr = birthdate.split('-')
  const birthYear = parseInt(birthdateArr[0])
  const birthMonth = parseInt(birthdateArr[1]) - 1
  const birthDay = parseInt(birthdateArr[2])

  const birthdateObj = new Date(birthYear, birthMonth, birthDay)
  let age = today.getFullYear() - birthdateObj.getFullYear()

  // 检查生日是否已经过了，如果生日还未到，则年龄减一
  const hasPassedBirthday = today.getMonth() > birthdateObj.getMonth() ||
    (today.getMonth() === birthdateObj.getMonth() && today.getDate() >= birthdateObj.getDate())
  if(!hasPassedBirthday) {
    age--
  }
  // 判断年龄类别
  if(age >= 18) {
    return '1'
  } else if(age >= 12) {
    return '1'
  } else if(age >= 1) {
    return '2'
  } else {
    return '3'
  }
}
</script>

<style lang="less" scoped>
.pad {
  padding: 20px;
}

/deep/ .van-cell__title {
  flex: none;
  margin-right: 12px;
}

.sex {
  padding: 10px 16px;
  display: flex;
}

.sexxt {
  color: #787890;
  width: 6.2em;
}

.semf {
  display: flex;
  width: 35%;
  justify-content: space-around;
}

/deep/ .van-radio__icon .van-icon {
  width: 1.20em;
  height: 1.20em;
}
</style>
